module.exports = __webpack_public_path__ + "static/media/grid1.9e8e1a2f.jpg";